<template>
  <div>
    <v-progress-linear
      v-if="loading && !forms"
      indeterminate
      color="rgb(86, 160, 153)"
      style="margin-top:20px;"
    />
    <v-data-table
      :headers="headers"
      :items="values"
      sort-by="calories"
      class="elevation-1"
      :items-per-page="itemsPerPage"
      :loading="loading"
      hideDefaultFooter
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <!-- <v-spacer /> -->
          <v-btn v-if="values" @click="handleExportToPDF"><v-icon>mdi-file-pdf-box</v-icon></v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <v-text-field
            v-if="handleSearch"
            solo
            :label="$t('common.search')"
            append-icon="mdi-magnify"
            style="margin-top:30px;"
            v-model="search"
            @input="handleSearch"
          />
          <v-spacer />           
          <v-select 
            v-model="selectedForm"
            :items="forms"
            :label="$t('dtouch.formCio.form', locale)"
            item-text="Name"
            item-value="ID"
            outlined
            dense
            hide-details
            @change="handleChangeSelectedForm"
          />
        </v-toolbar>
      </template>
      <template v-slot:no-data>
        {{ $t('common.noData', locale)}}
      </template>
    </v-data-table>
    <v-layout wrap>
      <v-flex xs2>
        <v-select
            solo
            :label="$t('common.show')"
            v-model="itemsPerPage"
            :items="[
              { ID: 100000, Name: 'All'},
              { ID: 5, Name: '5'},
              { ID: 10, Name: '10'},
              { ID: 25, Name: '25'},
            ]"
            item-text="Name"
            item-value="ID"
            @change="handleGetValues"
            style="margin: 5px;"
          />
      </v-flex>
      <v-flex xs10 
        v-if="pageCount > 0"
        style="padding-top: 10px;padding-left: 10px;padding-right: 10px;"
      >
        <v-pagination
          v-model="page"
          :length="pageCount"
          @input="handleChangePage"
        />
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'
  import _ from 'lodash'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import i18n from '@/plugins/i18n'
  export default {
    data: () => ({
      forms: null,
      selectedForm: null,
      title: '',
      config: null,
      headers: [],
      count: null,
      page: 1,
      loading: false,
      search: '',
      itemsPerPage: 10,
      pageCount: 0,
      values: [],
      bruteValues: [],
      handleSearch: null,
    }),
    computed: {
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      locale () {
        return i18n.locale
      },
    },
    watch: {
      enterpriseID (v, old) {
        if (old !== v && v) this.handleGetFormsConfig()
      },
      bruteValues () {
        this.handlePrepareValues()
      },
      config () {
        this.handlePrepareValues()
      },
    },
    mounted () {
      this.handleSearch = _.debounce(() => {
        this.handleGetValues()        
      }, 500)
      this.handleGetFormsConfig()
    },
    methods: {
      handleGetFormsConfig () {
        api.getAll(`enterprises/${this.enterpriseID}/form-cio`, true)
          .then(response => {
            this.forms = response
            if (this.forms.length > 0) this.selectedForm = this.forms[0].ID
            this.handleChangeSelectedForm()
          })
      },
      handleChangeSelectedForm () {
        this.title = ''
        this.headers = []
        this.page = 1
        this.pageCount = 0
        this.values = []
        this.bruteValues = []
        if (!this.selectedForm) return

        this.handleGetValues()

        api.getAll(`enterprises/${this.enterpriseID}/form-cio/${this.selectedForm}`, true)
          .then(response => {
            const aux = response.shift()
            if (!aux) return
            this.title = aux.Name
            this.config = JSON.parse(aux.Config)
            this.headers = this.config.filter(x => x.type !== 'info').map(item => {
              return {
                text: utils.getTranslation(item.label, this.locale),
                align: 'start',
                sortable: false,
                value: item.id,
              }
            })

            this.headers.push({
                text: this.$t('settings.formTerms.privacyPolicy', this.locale),
                align: 'center',
                sortable: false,
                value: 'AgreePrivacyPolicy',
              })
          })
      },
      handleChangePage () {
        this.handleGetValues()
      },
      handleGetValues () {
        this.loading = true
        api.getAll(`enterprises/${this.enterpriseID}/form-cio/${this.selectedForm}/values`, true, this.page, this.itemsPerPage, this.search)
          .then(response => {
            this.count = response.count
            let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
            if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
            this.pageCount = page
            
            this.bruteValues = response.data
            this.loading = false
          })
      },
      handlePrepareValues () {
        this.values = []
        if (!this.config || !this.bruteValues) return

        this.values = this.bruteValues.map(item => {
          const aux = {}
          item.values = JSON.parse(item.Values)
          for (const i of item.values) {
            const c = this.config.filter(x => x.id === i.id).shift()
            if (!c || !i.value) continue
            if (c.type === 'checkbox') {
              aux[i.id] = i.value ? 'Si' : 'No'
            } else if (c.type === 'select') {
              const s = c.items.filter(x => x.id === i.value).shift()
              aux[i.id] = s ? utils.getTranslation(s.name, this.locale) : ''
            } else if (c.type === 'selectMultiple') {
              const tmp = []
              aux[i.id] = ''
              for (const v of i.value) {
                const s = c.items.filter(x => x.id === v).shift()
                tmp.push(s ? utils.getTranslation(s.name, this.locale) : '')
              }
              aux[i.id] = tmp.join(', ')
            } else {
              aux[i.id] = i.value
            }
          }
          aux.AgreePrivacyPolicy = item.AgreePrivacyPolicy !== null ? item.AgreePrivacyPolicy ? 'SI' : 'NO' : '' 
          return aux
        })
      },
      handleExportToPDF () {
        const doc = new jsPDF('l')

        doc.autoTable({ html: '#my-table' })

        const body = []
        for (const v of this.values) {
          body.push([...this.headers.map(item => {
            return v[item.value] ? v[item.value] : ''
          })])
        }
        doc.autoTable({
          //head: [[i18n.t('rcovid.name'), i18n.t('rcovid.ni'), i18n.t('rcovid.phone'), , i18n.t('rcovid.LMD')]],
          head: [[...this.headers.map(item => item.text)]],
          body
        })

        doc.save(`${this.title}.pdf`)
      },
    },
  }
</script>
